import { BaseFilters } from '@/models/Service';
import { ListResourceFilters } from './_deprecated/resourceServices';
import requester from '@/lib/axios';
import JsonApiResponse from '@/models/JsonApiResponse';
import { ResourceProgress } from '@/models/ResourceProgress';

const baseUrl = 'resource-progress';

export type ListResourceProgressFilters = BaseFilters &
  ListResourceFilters & {
    resourceId?: number[];
  };

export async function listResourceProgress(
  params: ListResourceProgressFilters = {},
) {
  const { data } = await requester().get<JsonApiResponse<ResourceProgress>>(
    `${baseUrl}/`,
    {
      params,
    },
  );

  return data;
}

export async function getResourceProgress(resourceProgressId: number) {
  const { data } = await requester().get<ResourceProgress>(
    `${baseUrl}/${resourceProgressId}/`,
  );

  return data;
}

export async function createResourceProgress(body: Partial<ResourceProgress>) {
  const { data } = await requester().post<ResourceProgress>(
    `${baseUrl}/`,
    body,
  );

  return data;
}

type ResourceProgressRequest = {
  resourceProgressId: number;
  body: Partial<ResourceProgress>;
};

export async function updateResourceProgress({
  resourceProgressId,
  body,
}: ResourceProgressRequest) {
  const { data } = await requester().patch<ResourceProgress>(
    `${baseUrl}/${resourceProgressId}/`,
    body,
  );

  return data;
}
